export default "__VITE_ASSET__CtZ6l0Qu__"